/**
 * Smooth-scrolls to an on-page anchor when a CTA links to one (e.g. a button
 * that jumps to the Lead Form block). Landing pages render as a single page
 * inside the #mlp-root scroll container, and section blocks expose their
 * `sectionId` as the wrapper element id — so a link whose href ends in
 * `#<sectionId>` resolves to an element on the current page.
 *
 * Returns true if it handled the click (and called preventDefault); false when
 * the href is not an on-page anchor, so the caller lets the browser navigate.
 *
 * Used by About/Opening Component 2 (ASH-1954) and Component 3 (ASH-1984).
 */
export function handleAnchorScroll(
  e: { preventDefault: () => void },
  href: string | undefined,
): boolean {
  if (!href) return false
  const hashIndex = href.indexOf("#")
  if (hashIndex === -1) return false

  const id = href.slice(hashIndex + 1)
  if (!id) return false

  const target = document.getElementById(id)
  if (!target) return false // not on this page — let the browser navigate

  e.preventDefault()
  target.scrollIntoView({ behavior: "smooth", block: "start" })
  // reflect the anchor in the URL without an extra jump
  if (typeof history !== "undefined") history.replaceState(null, "", `#${id}`)
  return true
}
